<template>
  <div>
  <Card>
      <Row>
        <i-col span="24">
          <Form :model="searchForm" ref="searchForm" inline class="server-list">
          <FormItem label="主机名">
            <Input v-model="searchForm.hostname" style="min-width: 100px" />
          </FormItem>
          <FormItem label="私有IP">
            <Input v-model="searchForm.inner_ip" style="min-width: 100px" />
          </FormItem>
          <FormItem label="公网IP">
            <Input v-model="searchForm.public_ip" style="min-width: 100px" />
          </FormItem>
          <FormItem label="操作系统">
            <Select v-model="searchForm.os" style="min-width:100px">
              <Option v-for="item in osList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem :label-width="0" class="mob-align-right">
            <Button type="primary" @click="getServers()">搜索</Button>
            <Button style="margin-left: 8px" @click="searchReset">重置</Button>
          </FormItem>
        </Form>
        </i-col>
       </Row>
        <Row>
          <Table
            ref="table"
            size="small"
            :columns="columns"
            :data="tableData"
            :loading="table_loading"
          ></Table>
          <div style="margin: 10px 0; overflow: hidden;">
            <div style="float: right;">
              <page :total="count" :current="page" :page-size="size" @on-change="getServers"></page>
            </div>
          </div>
        </Row>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import { getAgentServer, getAgentList, updateAgent, unInstallAgent } from '@/api/opscenter'
import { getBaseMonitorOne } from '@/api/monitor'
export default {
  name: 'ServerList',
  components: {
    Tables
  },
  data () {
    return {
      osList: [
        {
          value: 0,
          label: 'Linux'
        },
        {
          value: 1,
          label: 'Windows'
        }
      ],
      count: 0,
      size: 10,
      page: 1,
      latestWinVersion: '',
      latestLinuxVersion: '',
      columns: [
        {
          minWidth: 100,
          title: '主机名',
          tooltip: true,
          key: 'hostname',
          align: 'center'
        },
        {
          minWidth: 100,
          title: '主机ID',
          tooltip: true,
          align: 'center',
          key: 'server_id'
        },
        {
          minWidth: 100,
          title: '别名',
          tooltip: true,
          align: 'center',
          key: 'name'
        },
        {
          minWidth: 100,
          title: '操作系统',
          align: 'center',
          key: 'os',
          render: (h, params) => {
            let k = { 0: 'Linux', 1: 'Windows' }
            if (params.row.os === 0 || params.row.os === 1) {
              return h('div', k[params.row.os])
            } else {
              return ''
            }
          }
        },
        {
          minWidth: 110,
          title: '私有IP',
          align: 'center',
          key: 'inner_ip'
        },
        {
          minWidth: 130,
          title: '公网IP',
          align: 'center',
          key: 'public_ip'
        },
        {
          minWidth: 100,
          title: '版本号',
          align: 'center',
          key: 'agent_version'
        },
        {
          minWidth: 120,
          title: 'Agent状态',
          align: 'center',
          key: 'status',
          render: (h, params) => {
            const row = params.row
            const color = row.status === 0 ? 'error' : row.status === 1 ? 'success' : 'warning'
            const text = row.status === 0 ? '断开' : row.status === 1 ? '运行' : '未知'
            // 未安装， 正常， 异常
            return h('Tag', {
              props: {
                type: 'dot',
                color: color
              }
            }, text)
          }
        },
        {
          title: '操作',
          width: 170,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              // h('Button', {
              //   props: {
              //     type: 'warning',
              //     size: 'small'
              //   },
              //   style: {
              //     marginRight: '5px'
              //   },
              //   on: {
              //     click: () => {
              //       this.handleInstall(params)
              //     }
              //   }
              // }, '安装'),

              h('Button', {
                props: {
                  type: 'success',
                  size: 'small',
                  disabled: params.row.status === 1 ? params.row.os === 1 ? params.row.agent_version === this.latestWinVersion : params.row.agent_version === this.latestLinuxVersion : true
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.handleUpdate(params)
                  }
                }
              }, '升级'),
              h('Poptip', {
                props: {
                  confirm: true,
                  placement: 'bottom',
                  title: '你确定要卸载Agent吗?'
                },
                on: {
                  'on-ok': () => {
                    this.handleDelete(params)
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small',
                    disabled: params.row.status !== 1
                  }
                }, '卸载')
              ])
            ])
          }
        }
      ],
      tableData: [],
      table_loading: false,
      searchForm: {
        hostname: '',
        inner_ip: '',
        public_ip: '',
        os: ''
      }
    }
  },
  methods: {
    getAgentList () {
      let params = {
        search: this.searchForm.name
      }
      getAgentList(params).then(res => {
        this.latestWinVersion = res.data.filter(item => item.os_type === '1' && item.is_latest === true).map(m => m.version)[0]
        this.latestLinuxVersion = res.data.filter(item => item.os_type === '0' && item.is_latest === true).map(m => m.version)[0]
        // console.log(this.latestWinVersion)
        // console.log(this.latestLinuxVersion)
      })
    },
    getServers (value = 1) {
      this.page = value
      this.table_loading = true
      this.searchForm['size'] = this.size
      this.searchForm['page'] = this.page
      getAgentServer(this.searchForm).then(res => {
        let result = res.data
        let tableData = result.results
        this.count = result.count
        let hostnames = []
        for (let i in result.results) {
          if (result.results[i].hostname) {
            hostnames.push(result.results[i].hostname)
          }
        }
        let reqParams = {
          'hostnames': hostnames,
          'counters': ['mem.memused.percent', 'cpu.user', 'df.statistics.used.percent', 'agent.alive']
        }
        getBaseMonitorOne(reqParams).then(monitorRes => {
          let MonitorDataResult = monitorRes.data
          if (MonitorDataResult.code === 200) {
            for (let l in tableData) {
              let hostname = tableData[l].hostname
              let cpuUsage = ''
              let memoryUsage = ''
              let diskUsage = ''
              let agentAlive = 0
              let timestamp = ''
              if (hostname) {
                if (MonitorDataResult.data[hostname]['timestamp']) {
                  cpuUsage = MonitorDataResult.data[hostname]['cpu.user']
                  memoryUsage = MonitorDataResult.data[hostname]['mem.memused.percent']
                  diskUsage = MonitorDataResult.data[hostname]['df.statistics.used.percent']
                  agentAlive = MonitorDataResult.data[hostname]['agent.alive']
                  timestamp = MonitorDataResult.data[hostname]['timestamp']
                }
              }
              tableData[l]['status'] = agentAlive
              tableData[l]['cpu_usage'] = cpuUsage
              tableData[l]['memory_usage'] = memoryUsage
              tableData[l]['disk_usage'] = diskUsage
              tableData[l]['timestamp'] = timestamp
            }
          } else {
            this.$Notice.error({
              title: '获取监控数据失败！',
              desc: MonitorDataResult.msg
            })
          }
          this.tableData = tableData
          this.table_loading = false
        }).catch(res => {
          this.tableData = tableData
          this.table_loading = false
          if (res.request) {
            this.$Notice.error({
              title: '获取监控数据失败！请求状态码:' + res.request.status,
              desc: res.request.responseText
            })
          }
        })
      })
    },
    searchReset () {
      this.searchForm.hostname = ''
      this.searchForm.inner_ip = ''
      this.searchForm.public_ip = ''
      this.searchForm.os = ''
    },
    handleUpdate (params) {
      console.log(params)
      if (params.row.id) {
        let ids = [params.row.id]
        let version = params.row.os === 0 ? this.latestLinuxVersion : this.latestWinVersion
        let data = { 'ids': ids, 'version': version }
        updateAgent(data).then(res => {
          if (res.data.code === 200) {
            this.getServers()
          } else {
            // this.$Notice.error({title: res.data})
            this.$Message.error(res.data.msg)
          }
        }).catch(res => {
          console.log(res.response)
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        })
      } else {
        this.$Notice.error({title: '请至少选择一台主机进行升级！'})
      }
    },
    handleInstall () {
    },
    handleDelete (params) {
      console.log(params)
      if (params.row.id) {
        let ids = [params.row.id]
        let version = params.row.os === 0 ? this.latestLinuxVersion : this.latestWinVersion
        let data = { 'ids': ids, 'version': version }
        unInstallAgent(data).then(res => {
          if (res.data.code === 200) {
            this.getServers()
          } else {
            // this.$Notice.error({title: res.data})
            this.$Message.error(res.data.msg)
          }
        }).catch(res => {
          console.log(res.response)
          this.$Notice.error({
            title: '操作失败！ 错误状态码:' + res.request.status,
            desc: res.request.responseText
          })
        })
      } else {
        this.$Notice.error({title: '请至少选择一台主机进行卸载！'})
      }
    }
  },
  mounted: function () {
    this.getAgentList()
    this.getServers()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
@media screen and (min-width:640px){
  .server-list .ivu-form-item-content{
    display: inline-block;
  }
}
@media screen and (max-width:640px){
  .server-list .ivu-form-item-content{
    margin-left:75px;
  }
  .server-list .ivu-form-item-label{
    width:75px;
  }
  .server-list .ivu-input-wrapper{
    width:100%;
  }
}
</style>
